import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Ability } from '@casl/ability';
import CompanyItem from '../../companyItem/CompanyItem';
import CompanyList from '../../companyList/CompanyList';
import SettingMenu from '../../settingMenus/SettingMenus';
import arrowDown from '../../../assets/arrow-down.svg';
import { CompanyDto, UserDto } from '@jaam/commons/dtos';
import CompanyMenu from '../../companyMenu/CompanyMenu';
import { Actions, Subjects, PermissionObjectType } from '../../../helpers';
import {
  AddCircle24Regular,
  Dismiss20Regular,
  Dismiss24Regular,
} from '@fluentui/react-icons';
import { Button } from '../../ui/button';
interface Props {
  activeCompany: CompanyDto;
  companies?: CompanyDto[];
  isLoadingCompanies?: boolean;
  user: UserDto;
  logoutHandler: () => void;
  handleCompanyClick?: (company: CompanyDto) => void;
  handleNewCompany: () => void;
  setCloseSettingsPanel: (value: boolean) => void;
  ability?: Ability<[Actions, Subjects], PermissionObjectType>;
  minimalView?: boolean;
}

export const SettingsPanel = ({
  user,
  activeCompany: company,
  isLoadingCompanies,
  companies,
  logoutHandler,
  handleNewCompany,
  handleCompanyClick,
  setCloseSettingsPanel,
  ability,
  minimalView = false,
  ...props
}: Props) => {
  const { t } = useTranslation();
  const [companyListStatus, setcompanyListStatus] = useState<boolean>(false);
  const initials = `${user.firstName?.charAt(0).toUpperCase() || ''}${
    user.lastName?.charAt(0).toUpperCase() || ''
  }`;
  const ref = useRef<HTMLDivElement>(null);
  const companyListHandler = () => {
    const status = !companyListStatus;
    setcompanyListStatus(status);
  };
  const hideCompanyList = () => {
    if (companyListStatus) {
      setcompanyListStatus(false);
    }
  };

  const onClose = () => setCloseSettingsPanel(false);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) onClose();
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return (
    <div className="" ref={ref}>
      <div
        onClick={hideCompanyList}
        aria-hidden="true"
        className="w-full h-screen bg-neutral-95 sm:shadow-panelBoxShadow overflow-y-auto fixed overflow-x-hidden
        sm:w-[350px] sm:h-[90%]  sm:rounded-[20px] sm:top-12 top-10 sm:left-8

        pb-10 "
        {...props}
      >
        <div className="relative bg-transparent border-0 ">
          <div className="justify-between hidden p-4 sm:flex">
            <div className="hidden px-2 py-3 text-xl font-semibold text-center text-neutral-20 sm:block ">
              {t('menu.profile')}
            </div>
            <button
              onClick={onClose}
              type="button"
              className="flex w-10 h-10 p-0 text-base text-center align-middle bg-transparent border-0 shadow-none outline-none max-sm:hidden"
            >
              <span className="flex items-center justify-center w-10 h-10 rounded-full text-blue-00 hover:bg-blue-95">
                <Dismiss20Regular />
              </span>
            </button>
          </div>

          <div className="mt-8 text-neutral-20 ">
            <div className="flex items-center justify-center ">
              <div className="relative flex items-center justify-center w-16 h-16 mb-5 rounded-full border-[3px] border-primary bg-neutral-95 text-lg font-semibold ">
                {initials}
              </div>
            </div>
            <div className="mb-8 text-center ">{user.email}</div>
          </div>
        </div>
        {company ? (
          <div className="relative mx-4 bg-white rounded-2xl">
            <div className="p-2">
              <CompanyItem
                company={company}
                handleClick={() => {
                  if (handleCompanyClick) handleCompanyClick(company);
                }}
                showUserCompanies={companyListHandler}
                checkIcon={arrowDown}
                active
                companyListStatus
              />
            </div>
            {!minimalView && (
              <CompanyMenu
                ability={ability}
                setCloseSettingsPanel={setCloseSettingsPanel}
              />
            )}
            {companyListStatus && (
              <div className="absolute top-[72px] max-sm:left-[50px] max-sm:right-3 z-20 p-2 pb-8 mx-auto md:w-full bg-white shadow-panelBoxShadow rounded-3xl flex flex-col gap-2 ">
                {!isLoadingCompanies && (
                  <CompanyList
                    handleClick={(company) => {
                      if (handleCompanyClick) handleCompanyClick(company);
                    }}
                    compagnies={companies || []}
                    activeCompany={company}
                  />
                )}
                <Button
                  disabled={!navigator.onLine}
                  variant="secondary"
                  className="w-full "
                  onClick={handleNewCompany}
                  data-testid="new-company-button"
                >
                  New
                </Button>
              </div>
            )}
          </div>
        ) : null}
        <div className="px-4 ">
          <SettingMenu
            setCloseSettingsPanel={setCloseSettingsPanel}
            logout={logoutHandler}
            minimalView={minimalView}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(SettingsPanel);
